import { errorToast } from "@/v2-ui/toast"
import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import { useUserStatusUpdateMutation } from "@/v2-backoffice-client/user/status/update/user.status.update.mutation"
import {
  USER_STATUS_UPDATE_ACTIONS,
  USER_STATUS_UPDATE_CODES,
} from "@/v2-backoffice-client/user/status/update/user.status.update.constants"

export type UserStatusUpdateActionsProps = {
  userId: number
  currentStatusCode: number
}

// Every status the user isn't already in, as action-menu items. The button
// counterpart is UserStatusUpdateButton, which renders one status at a time
// so a toolbar can lay them out itself.
function UserStatusUpdateActions(props: UserStatusUpdateActionsProps) {
  const { userId, currentStatusCode } = props

  const [setStatus, { loading, error }] = useUserStatusUpdateMutation()
  errorToast(error, { title: "Failed to update account status" })

  const codes = USER_STATUS_UPDATE_CODES.filter(
    (code) => code !== currentStatusCode,
  )

  return (
    <>
      {codes.map((code) => {
        const action = USER_STATUS_UPDATE_ACTIONS[code]

        return (
          <ActionMenu.ConfirmItem
            key={code}
            iconSrc={action.iconSrc}
            variant={action.variant}
            isLoading={loading}
            confirmTitle={action.menuLabel}
            confirmDescription={action.confirmContent}
            confirmText={action.menuLabel}
            onConfirm={() => {
              setStatus({ variables: { id: userId, userStatusCode: code } })
            }}
          >
            {action.menuLabel}
          </ActionMenu.ConfirmItem>
        )
      })}
    </>
  )
}

export default UserStatusUpdateActions
